class Footer {
  constructor(container) {
    this.container = container;
    this.backToTopButton = container.querySelector('[data-footer-back-to-top]');
    this.init();
  }

  init() {
    if (!this.backToTopButton) return;

    this.backToTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.footer').forEach((footer) => {
    new Footer(footer);
  });
});
